module.exports = __webpack_public_path__ + "img/wifiblock-mobile-kitchen.94da78da.png";